import { Col, Form, Row } from 'antd';
import { FormItem, FormItemProps } from 'components/Form/FormItem';
import { FormattedMessage } from 'react-intl';
import { Commodity } from '@enmon/commons';
import { BinarySelect } from '../../../../Select/meter_details/Binary';
import { DiameterNominalSelect } from '../../../../Select/meter_details/DiameterNominal';
import { FlowrateSelect, FlowrateUnitSelect } from '../../../../Select/meter_details/Flowrate';
import { InstallationPositionSelect } from '../../../../Select/meter_details/thermal/InstallationPosition';
import { ResistanceSelect } from '../../../../Select/meter_details/thermal/Resistance';
import { ThermalMeasurementTypeSelect } from '../../../../Select/meter_details/ThermalMeasurementType';
import { LayLengthSelect } from '../../../../Select/meter_details/LayLength';
import { OrientationSelect } from '../../../../Select/meter_details/Orientation';
import { MeterDetails as messages } from '../../messages';
import { ThermalMeterDetailField } from '../constants';

export interface AdditionalThermalDetails {
  flowrateUnit?: string | null;
  flowrateValue?: number | null;
}

export const getThermalDetailFormItem = (
  field: ThermalMeterDetailField,
  formItemProps: FormItemProps,
  { flowrateUnit, flowrateValue }: AdditionalThermalDetails,
) => {
  switch (field) {
    case ThermalMeterDetailField.Flange:
      return (
        <FormItem
          label={<FormattedMessage {...messages.flange} />}
          name={['detail', 'flange']}
          tooltip={<FormattedMessage {...messages.flangeTooltip} />}
          {...formItemProps}
        >
          <BinarySelect name="flange" />
        </FormItem>
      );
    case ThermalMeterDetailField.Orientation:
      return (
        <FormItem
          label={<FormattedMessage {...messages.orientation} />}
          name={['detail', 'orientation']}
          {...formItemProps}
        >
          <OrientationSelect />
        </FormItem>
      );
    case ThermalMeterDetailField.ThermalMeasurementType:
      return (
        <FormItem
          label={<FormattedMessage {...messages.thermalMeasurementType} />}
          name={['detail', 'thermalMeasurementType']}
          {...formItemProps}
        >
          <ThermalMeasurementTypeSelect />
        </FormItem>
      );
    case ThermalMeterDetailField.Flowrate:
      return (
        <FormItem
          label={<FormattedMessage {...messages.flowRate} />}
          name={['detail', 'flowrate', 'value']}
          tooltip={<FormattedMessage {...messages.flowRateTooltip} />}
          {...formItemProps}
        >
          <Row className="w-100" style={{ display: 'inline-flex' }} wrap={false}>
            <Col span={7}>
              <Form.Item noStyle initialValue={flowrateUnit} name={['detail', 'flowrate', 'unit']}>
                <FlowrateUnitSelect commodity={Commodity.Thermal} />
              </Form.Item>
            </Col>
            <Col span={17}>
              <Form.Item noStyle initialValue={flowrateValue} name={['detail', 'flowrate', 'value']}>
                <FlowrateSelect unit={flowrateUnit} />
              </Form.Item>
            </Col>
          </Row>
        </FormItem>
      );
    case ThermalMeterDetailField.LayLength:
      return (
        <FormItem
          label={<FormattedMessage {...messages.layLength} />}
          name={['detail', 'layLength']}
          tooltip={<FormattedMessage {...messages.layLengthTooltip} />}
          {...formItemProps}
        >
          <LayLengthSelect commodity={Commodity.Thermal} />
        </FormItem>
      );
    case ThermalMeterDetailField.DiameterNominal:
      return (
        <FormItem
          label={<FormattedMessage {...messages.diameterDimensionNominal} />}
          name={['detail', 'diameterNominal']}
          tooltip={<FormattedMessage {...messages.diameterDimensionNominalTooltip} />}
          {...formItemProps}
        >
          <DiameterNominalSelect />
        </FormItem>
      );
    case ThermalMeterDetailField.Resistance:
      return (
        <FormItem
          label={<FormattedMessage {...messages.resistance} />}
          name={['detail', 'resistance']}
          tooltip={<FormattedMessage {...messages.resistanceTooltip} />}
          {...formItemProps}
        >
          <ResistanceSelect />
        </FormItem>
      );
    case ThermalMeterDetailField.InstallationPosition:
      return (
        <FormItem
          label={<FormattedMessage {...messages.installationPosition} />}
          name={['detail', 'installationPosition']}
          tooltip={<FormattedMessage {...messages.installationPositionTooltip} />}
          {...formItemProps}
        >
          <InstallationPositionSelect />
        </FormItem>
      );
    default:
      return null;
  }
};
